import { useCallback, useEffect, useState } from "react";

import { SEARCH_DEBOUNCE_MS } from "../../../utils/constants";
import { FilterValues } from "../components/TransactionsFilters/types";
import { getDefaultFilters } from "../TransactionsPage/utils";

export interface UseTransactionFiltersReturn {
  filters: FilterValues;
  debouncedSearch: string;
  onValuesChange: (patch: Partial<FilterValues>) => void;
}

export const useTransactionFilters = (): UseTransactionFiltersReturn => {
  const [filters, setFilters] = useState<FilterValues>(getDefaultFilters);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(filters.searchBy);
    }, SEARCH_DEBOUNCE_MS);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [filters.searchBy]);

  const onValuesChange = useCallback((patch: Partial<FilterValues>) => {
    setFilters((prev) => {
      const next = { ...prev, ...patch };
      const typeChanged = patch.type && patch.type.value !== prev.type.value;
      if (typeChanged) {
        next.category = null;
      }
      return next;
    });
  }, []);

  return { filters, debouncedSearch, onValuesChange };
};
